import schedule_2 from '@/public/features/accounting/Comprehensive Financial Tracking.webp';
import schedule_5 from '@/public/features/accounting/Frame 3478.webp';
import bg from '@/public/features/accounting/Frame 1171278053.webp';
import schedule_4 from '@/public/features/accounting/Schedule.webp';
import schedule_1 from '@/public/features/accounting/Vendor Coordination Interface.webp';
import app_2 from '@/public/features/accounting/What is invoicing software.webp';
import explore_image from '@/public/features/explore.webp';
// import schedule_3 from '@/public/features/sales/Streamline-Payment-Processes-with-Ease.webp';
import app_1 from '@/public/features/gps_tracking/App_1.webp';
import { CalendarIcon, CardIcon, ToolsIcon, WalletIcon } from '@/public/icons';
import { ArticleType } from '@/types/articles';
import { IRoutePath } from '@/types/router';

const intro = {
  tag: 'Field Service Accounting Software',
  description: `Our free field service accounting software helps businesses streamline financial management effortlessly. Ideal for companies of all sizes, it offers easy invoicing, expense tracking, and reporting. Boost efficiency and stay organized with our intuitive solution.`,
  imageSrc: bg.src,
  image: bg,
  first_title: 'Free Field Service Accounting',
  second_title: 'Software for Your Business',
};

const faq = {
  title: 'FAQ',
  items: [
    {
      title: `How Does Accounting Software for Field Services Work?`,
      text: `Field service accounting software automates financial assignments like invoicing, expense tracking, and payroll. It combines with your existing instruments to provide real-time financial data, eradicating manual entrances and simplifying your accounting operations.`,
    },
    {
      title: `How Can Accounting Software Help a Field Service Business?`,
      text: `Field services accounting software can automate your financial tasks, eliminate errors, and give you insights into your finances in real-time. By doing this, you can control expenses, record payments and be able to make rapid business decisions.`,
    },
    {
      title: `Is Orcatec Accounting Software Free?`,
      text: `Yes, its free software includes essential features designed to help new and small businesses streamline their operations without any initial financial commitment. It also has more advanced paid features that create the complete space for successful accounting management.`,
    },
    {
      title: `What Are the Benefits of Using Accounting Software for Service Contractors?`,
      text: `Accounting software for service contractors automatedly makes ease in financial management through the management of expenses, tracking invoices, and payrolls. It also provides a very detailed financial statement with increased accuracy and time-saving; this can help contractors make wise business decisions in order to maximize profits.`,
    },
  ],
};

const testimonals = {
  title: 'Client’s Testimonials',
  description: '',
  items: [
    {
      text: `We are blown away by Orcatec customer service. Their team helps us to address them even promptly, and hold their promise that they always have hands on deck. It is comforting to know that our support systems are dependable.`,
      name: 'John L.',
      position: 'IT Director',
    },
    {
      text: `Orcatecs solutions have made a big impact on the efficiency of our work. The logical approach to the utilization of their tools has been very user-friendly for our team. It has made such a big difference in our workflow and productivity.`,
      name: 'Emily R.',
      position: 'Project Coordinator',
    },
    {
      text: `Got a good deal with Orcatec. Their solutions are both cost-effective and scalable, and this has been very important for us as we have expanded our business. Abstract is something we launched with a very basic package, and have then been able to grow alongside our needs.`,
      name: 'Mark T.',
      position: 'CEO',
    },

    {
      text: `We are blown away by Orcatec customer service. Their team helps us to address them even promptly, and hold their promise that they always have hands on deck. It is comforting to know that our support systems are dependable.`,
      name: 'John L.',
      position: 'IT Director',
    },
    {
      text: `Orcatecs solutions have made a big impact on the efficiency of our work. The logical approach to the utilization of their tools has been very user-friendly for our team. It has made such a big difference in our workflow and productivity.`,
      name: 'Emily R.',
      position: 'Project Coordinator',
    },
    {
      text: `Got a good deal with Orcatec. Their solutions are both cost-effective and scalable, and this has been very important for us as we have expanded our business. Abstract is something we launched with a very basic package, and have then been able to grow alongside our needs.`,
      name: 'Mark T.',
      position: 'CEO',
    },
  ],
};

const blog = {
  title: 'Our Blog',
  description: `We review recent trends, insights, and lessons learned in the world of field service that provide valuable information you can use to improve your operations – keeping best practices top-of-mind and helping you achieve even better results.`,
};

const bookDemo = {
  title: `Get more benefits when you start\xa0your\xa0business\xa0with\xa0Orcatec`,
  description: `Participate in the transformative power of Orcatec’s review management software for any business. Enhance your online standing, draw more customers, and simplify your client feedback process effortlessly. Fill in the form below to get started for free.`,
};

const articles = {
  title: `How Does Service Business Accounting\xa0Software\xa0Work?`,
  items: [
    {
      type: ArticleType.VERICAL,
      image: {
        path: schedule_1,
        alt: 'On-Site Proposal Creation',
      },
      list: [],
      href: '#',
      tag: '',
      title: 'Real-Time Financial Overview',
      text: `Our free accounting software for service business offers a full 360-view at any point in time of how the finances are. It will easily integrate with other financial tools, from bank accounts to invoicing systems, without the need to punch in data it will itemize. In that respect, it makes sure you always have your most current financials and never make business decisions based on inaccurate information.`,
    },

    {
      type: ArticleType.VERICAL,
      image: {
        path: schedule_2,
        alt: 'Customer management',
      },
      list: [],
      href: '#',
      tag: '',
      title: 'Track Expenses and Payouts',
      text: `This tool helps you keep track of every little expense, payout, and balance within your account. It sorts expenses, tracks expenditures, and catalogs in-depth all of your financial transactions. One way it does this is by allowing you to do forecasting, which then provides a good insight into your cash flow and can identify where the money can be saved or where more spending is needed.`,
    },

    /*  {
      type: ArticleType.HORIZONTAL,
      image: {
        path: schedule_3,
        alt: 'Streamlined Approval Process',
      },
      list: [],
      href: '#',
      tag: '',
      title: `Customizable and Personalized\xa0Proposals`,
      text: `At the core of the software's functionality is its ability to produce highly customizable and personalized proposals. You can tailor every aspect of the proposal, from headers and layouts to itemized or total pricing, ensuring that each proposal reflects the unique value proposition you offer to the client.\n\nThis level of personalization helps to create a connection with the client and demonstrates a deep understanding of their needs.`,
    }, */
    {
      type: ArticleType.VERICAL,
      image: {
        path: schedule_5,
        alt: 'Customer management',
      },
      list: [],
      href: '#',
      tag: '',
      title: 'A Job Costs And Profit Analysis',
      text: `With robust reporting tools, the software allows you to see detailed job costing and profit of each project. This will itemize costs related to each job you do so that you can have a measure of how profitable your services are.\n\nYou can also generate different financial reports, like profit and loss accounts, balance sheets, and cash flows, in an attempt to gain a good view of the performance of the business.`,
    },
    {
      type: ArticleType.VERICAL,
      image: {
        path: schedule_4,
        alt: 'Customer management',
      },
      list: [],
      href: '#',
      tag: '',
      title: 'Easy Worker Payouts',
      text: `Service business accounting software makes managing payroll a hassle-free task. This makes your workers' payouts calculation much easier, and they get paid correctly and on time.\n\nIt accepts payments in the form of hourly wages, salaries, as well as commission-based structures and helps you manage and allocate worker compensation quickly too.`,
    },
  ],
};

const fullArticle1 = {
  image: {
    path: app_1,
    alt: `Why Orcatec is Right For You?`,
  },
  title: `Why Orcatec is\xa0Right\xa0For\xa0You?`,
  description: `With Orcatec solutions, you can scale as your needs grow and change. This flexibility affords you the headroom to start with what you need and expand as your business grows, always fitting your changing requirements. `,
  item: [
    {
      title: 'Advanced Technology',
      description:
        'It is a fact that to remain a leader in the fast-changing world of technology, Orcatec puts serious investments into research and development. We make sure that our solutions are current and provided with technological advancements, which therefore gives you that competitive edge.',
    },
    {
      title: 'Designed with the User in Mind',
      description: `We understand not everyone is a technology expert; in view of this, all of our products and tools are designed with the users' experience in mind. The tools are very intuitive and easy to navigate and therefore friendly to all classes of users in order to make work more productive and save valuable time spent in training.`,
    },
    {
      title: 'Reliable Customer Support',
      description: `Orcatec prides itself on its customer service, offering robust support through various channels. Whether you need troubleshooting help, customer service, or technical advice, our team is readily available to ensure that you get the most out of your purchase`,
    },
  ],
};

const fullArticle2 = {
  image: {
    path: app_2,
    alt: `What Is Field Service Accounting Software?`,
  },
  title: `What Is Field Service Accounting\xa0Software?`,
  description: `Accounting software for service business is one of the software applications designed for managing the service-oriented field operations of any business enterprise. It has been adapted by companies whose business model involves providing services at clients' premises, such as maintenance, repairs, installation, and other on-site services.\n\nThese financial management tools combine accounting processes with other elements of business operation in a bid to streamline the process, increase precision, and improve the operational efficiency of the process in general.`,
  item: [
    {
      title: '',
      description: 'Create and send invoices quickly and easily.',
    },
    {
      title: '',
      description: 'Monitor and manage expenses efficiently.',
    },

    {
      title: '',
      description: `Generate detailed financial reports for better decision-making.`,
    },
  ],
};

const explore = {
  title: 'Explore More ',
  subtitle: 'Tools For Job Success',
  description: `Dive into a wealth of insights tailored to your industry with Orcatec's blog, your go-to resource 
  for the latest trends and tips in service scheduling software free`,
  image: explore_image,
  items: [
    {
      title: 'Complete Job & Invoice',
      path: IRoutePath.FEATURES_INVOICING,
      icon: WalletIcon,
      items: [
        {
          title: 'Sales Proposal Tool',
          path: '',
        },

        {
          title: 'Invoicing',
          path: '',
        },
        {
          title: 'Estimates',
          path: '',
        },
        {
          title: 'Quoting',
          path: '',
        },
      ],
    },
    {
      title: 'Scheduling & Dispatching',
      path: IRoutePath.FEATURES_SCHEDULIG,
      icon: CalendarIcon,
      items: [
        {
          title: 'Employee GPS Tracking',
          path: '',
        },
        {
          title: 'Scheduling Software',
          path: '',
        },
        {
          title: 'Route Optimization',
          path: '',
        },
        {
          title: 'Field Service App',
          path: '',
        },
        {
          title: 'Voice Solutions',
          path: '',
        },
        {
          title: 'Dispatching',
          path: '',
        },
      ],
    },
    {
      title: 'Get Paid & Expenses',
      path: IRoutePath.FEATURES,
      icon: CardIcon,
      items: [
        {
          title: 'Commissions Management',
          path: '',
        },
        {
          title: 'Home Services Marketing',
          path: '',
        },
        {
          title: 'Automated Direct Mail',
          path: '',
        },
        {
          title: 'Consumer Financing',
          path: '',
        },
        {
          title: 'Advanced Reporting',
          path: '',
        },
        {
          title: 'Expenses Tracking',
          path: '',
        },

        {
          title: 'Contractor Payroll',
          path: '',
        },
        {
          title: 'Card Reader',
          path: '',
        },
      ],
    },
    {
      title: 'Job Management',
      icon: ToolsIcon,
      path: IRoutePath.FEATURES,
      items: [
        {
          title: 'Work Order Management',
          path: '',
        },
        {
          title: 'Field Service CRM',
          path: '',
        },
        {
          title: 'Job Management',
          path: '',
        },
        {
          title: 'Job Tracking',
          path: '',
        },
        {
          title: 'Job Costing',
          path: '',
        },
      ],
    },
  ],
};

export {
  articles,
  blog,
  bookDemo,
  faq,
  fullArticle1,
  fullArticle2,
  intro,
  testimonals,
  explore,
};
